fragment EmailableLead on Lead {
    id
    name
    number
    avatarUrl
    htmlUrl
    status
    priority
}
